import {getCurrentAppName} from '@github-ui/stats'
import {getCurrentRouteId} from '@github-ui/stats-metadata'
import {getFeatureFlags} from '../get-feature-flags'

export interface HydroPageContext {
  id: number
  app: string
  url: string
  dataRouter: boolean
  react: boolean
  reactApp?: string | null
  reactPartials: string[]
  featureFlags: string[]
  controller?: string
  action?: string
  routePattern?: string
  routeId?: string
  navigationId: string
}

let currentPageviewId = 0

export function advanceHydroPageview() {
  currentPageviewId += 1
}

export function __resetHydroPageContextForTesting() {
  currentPageviewId = 0
}

export function captureHydroPageContext(app = getCurrentAppName()): HydroPageContext {
  const reactApp = document.querySelector(`react-app[app-name="${CSS.escape(app)}"]`)
  return {
    id: currentPageviewId,
    app,
    url: window.location.href,
    dataRouter: reactApp?.getAttribute('data-data-router-enabled') === 'true',
    react: !!reactApp,
    reactApp: reactApp?.getAttribute('app-name'),
    reactPartials: [
      ...new Set(
        Array.from(document.querySelectorAll('react-partial')).map(
          partial => partial.getAttribute('partial-name') || '',
        ),
      ),
    ],
    featureFlags: getFeatureFlags(),
    controller: document.querySelector<HTMLMetaElement>('meta[name="route-controller"]')?.content,
    action: document.querySelector<HTMLMetaElement>('meta[name="route-action"]')?.content,
    routePattern: document.querySelector<HTMLMetaElement>('meta[name="route-pattern"]')?.content,
    routeId: getCurrentRouteId(),
    navigationId: getCurrentNavigationId(),
  }
}

function getCurrentNavigationId(): string {
  if (typeof navigation === 'undefined' || !('currentEntry' in navigation)) {
    return ''
  }

  // eslint-disable-next-line compat/compat -- we check just above this line
  return navigation.currentEntry?.id ?? ''
}
